import { render, staticRenderFns } from "./liquorStep1.vue?vue&type=template&id=8f695f72&"
import script from "./liquorStep1.vue?vue&type=script&lang=js&"
export * from "./liquorStep1.vue?vue&type=script&lang=js&"
import style0 from "./liquorStep1.vue?vue&type=style&index=0&id=8f695f72&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports